export const getAbsoluteUrl = (url) => {
    return `${process.env.NEXT_PUBLIC_LIVE_URL}${url}`;
};
